import React from 'react';
import PropTypes from 'prop-types';

import GroupInner from './GroupInner';
import Dialog from '../../../common/Dialog';

const CreateGroupDialog = ({
  studentsWithNoGroup,
  open,
  onClose,
  saving,
  onSave,
  uploadGroupAvatar,
}) => (
  <Dialog id="create-group" open={open} onClose={onClose} height="700">
    <GroupInner
      mode="create"
      studentsWithNoGroup={studentsWithNoGroup}
      saving={saving}
      onSave={onSave}
      onClose={onClose}
      uploadGroupAvatar={uploadGroupAvatar}
    />
  </Dialog>
);

CreateGroupDialog.propTypes = {
  studentsWithNoGroup: PropTypes.arrayOf(PropTypes.PropTypes.shape({})),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  uploadGroupAvatar: PropTypes.func.isRequired,
};

CreateGroupDialog.defaultProps = {
  studentsWithNoGroup: [],
};

export default CreateGroupDialog;
